import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AnalyticsService } from 'src/app/analytics.service';
import { PostViewImagesModalPage } from 'src/app/modals/post-view-images-modal/post-view-images-modal.page';
import { ImageService } from 'src/app/services/images.service';

@Component({
  selector: 'app-post-image',
  templateUrl: './post-image.component.html',
  styleUrls: ['./post-image.component.scss'],
})
export class PostImageComponent implements OnInit {
  tryCount = 0;
  MAX_TRY = 2;
  errorWithFile = false;
  path$: Observable<string>;
  @Input() allowExpansion = true;
  @Input() path: string;
  @Input() size?: '64' | '256' | '512' | '1080';
  @Input() edit: boolean;
  constructor(
    private imageSvc: ImageService,
    private modalCtrl: ModalController,
    private analytics: AnalyticsService,
  ) {}

  ngOnInit() {
    if (!this.size) {
      this.size = '512';
    }

    if (this.path) {
      this.path$ = this.imageSvc.getPostPhoto(this.path, this.size);
      let timer;
      const sub = this.path$.subscribe(
        () => {
          sub.unsubscribe();
          clearInterval(timer);
        },
        (err) => {
          timer = setInterval(() => {
            if (this.tryCount < this.MAX_TRY) {
              this.tryCount++;
              this.path$ = this.imageSvc.getPostPhoto(this.path, '512');
              const newSub = this.path$.subscribe(() => {
                newSub.unsubscribe();
                clearInterval(timer);
              });
            } else {
              clearInterval(timer);
              this.errorWithFile = true;
            }
          }, 5000);
        }
      );
    }
  }

  public async openViewImageModal() {
    this.analytics.logEvent('post_view_image_clicked', {
    });
    if (!this.allowExpansion) return false;
    const modal = await this.modalCtrl.create({
      component: PostViewImagesModalPage,
      componentProps: { imagePath: this.path },
    });

    return await modal.present();
  }
}
